<template>
  <div class="card-container" v-if="cardOpenStatus == '1'||preview">
    <!-- 名片 -->
    <div class="business-card" :style="{ background: bgImg,bottom:webinarLive ? '14vw':'8vw'}">
      <div class="card-content">
        <div class="content-info">
          <div class="card-header">
            <img :src="headImgUrl ? headImgUrl : headImg" alt="" />
          </div>
          <div class="card-info">
            <p v-if="uname" class="uname">{{ uname }}</p>
            <p v-else class="uname"></p>
            <p v-if="position" class="position">{{ position }}</p>
           <!-- <p v-else class="position">业务代表</p>-->
          </div>
        </div>
        <a :href="phoneNumber" v-if="callmeType == 'call'">
          <div v-if="buttonType == '1'" :style="{border:'1px solid '+buttonStyle}" class="mobile">
            <span :style="{ color: buttonStyle }">与我联系</span>
          </div>
          <div v-if="buttonType == '2'" class="mobile">
            <img :src="logUrl" style="width: 106px" alt="" />
          </div>
        </a>
        <a href="javascript:void(0);" v-if="callmeType == 'wecom'">
          <div v-if="buttonType == '1'" :style="{border:'1px solid '+buttonStyle}" class="mobile">
            <span :style="{ color: buttonStyle }" @click="callmeFn"
              >与我联系</span
            >
          </div>
          <div v-if="buttonType == '2'" class="mobile">
            <img :src="logUrl" style="width: 106px" alt="" />
          </div>
        </a>
      </div>
      <div class="card-bottom">
        <a
          class="more"
          target="_parent"
          v-if="linkText"
          :style="{ color: linkColor }"
          :href="linkUrl||'javascript:void(0)'"
          >{{ linkText }}</a
        >
        <a
          class="more"
          target="_parent"
          v-if="!linkText && promoterType == '1'"
          :style="{ color: linkColor }"
          :href="linkUrl ||'javascript:void(0)'"
          >{{ companyName }}</a
        >
        <a
          class="more"
          target="_parent"
          v-if="!linkText && promoterType == '2'"
          :style="{ color: linkColor }"
          :href="linkUrl||'javascript:void(0)'"
          >{{ agentName }}</a
        >
        <a
          class="more"
          target="_parent"
          v-if="!linkText && preview && logoPreview"
          :style="{ color: linkColor }"
          :href="linkUrl||'javascript:void(0)'"
          >&nbsp;</a
        >
        <a target="_parent" :href="logoLinkUrl || 'javascript:;'">
          <img
            v-if="logoPreview"
            class="cardLogo"
            :src="logoPreview"
            alt=""
          />
          <img v-if="!logoPreview&&logUrl" class="cardLogo" :src="logUrl" alt="" />
          <img
            v-if="!logoPreview&&!logUrl && companyLogoRealUrl"
            class="cardLogo"
            :src="companyLogoRealUrl"
            alt=""
          />
          <img
            v-if="!logoPreview&&!logUrl && agentLogoRealUrl"
            class="cardLogo"
            :src="agentLogoRealUrl"
            alt=""
          />
        </a>
      </div>
      <div @click="closeCard" class="closeBtn">
        <img src="../../../assets/close.png" alt="">
      </div>
    </div>
    <!-- 名片二维码 -->
    <div class="showQrCode" v-if="IsShowQrCode">
      <div class="top">
        <div class="code-content">
          <div class="info-left">
            <div class="code-header">
              <img :src="headImgUrl ? headImgUrl : headImg" alt="" />
          </div>
          <div class="code-info">
            <p v-if="uname" class="uname">{{ uname }}</p>
            <p v-else class="uname"></p>
            <p v-if="position" class="position">{{ position }}</p>
            <!-- <p v-else class="position">业务代表</p>-->
          </div>
          </div>
          <div @click="closeQrCode" class="closeCode">
           <img src="../../../assets/close.png" alt="">
          </div>
        </div>
        <div class="code-company">
          <a
            class="more"
            target="_parent"
            v-if="linkText"
            :style="{ color: linkColor }"
            :href="linkUrl"
            >{{ linkText }}</a
          >
          <a
            class="more"
            target="_parent"
            v-if="!linkText && promoterType == '1'"
            :style="{ color: linkColor }"
            :href="linkUrl"
            >{{ companyName }}</a
          >
          <a
            class="more"
            target="_parent"
            v-if="!linkText && promoterType == '2'"
            :style="{ color: linkColor }"
            :href="linkUrl"
            >{{ agentName }}</a
          >
        </div>
        <div class="code-code">
          <img :src="wecomQrCode" alt="" />
        </div>
        <div class="code-bottom">
        <p>长按识别二维码，添加我的企业微信</p>
      </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from "../../services/api";
import {ck, URLS} from "fire-wind-water";

export default {
  name: "card",
  props:['preview','webinarLive','tenantId'],
  data() {
    return {
      IsShowQrCode: false,
      bgUrl: require("../../../assets/bgImg.png"),
      headImg: require("../../../assets/header.png"),
      params: {
        markCode: "",
        taskId: "",
        tenantId: ""
      },
      //   config
      cardOpenStatus: "",
      bgImg: "",
      buttonType: "",
      buttonStyle: "",
      linkColor: "",
      linkText: "",
      linkUrl: "",
      logUrl: "",
      logoLinkUrl: "",
      phoneNumber: "",
      callmeType: "",
      logoPreview: "",
      //   promoterInfo
      promoterType: "",
      uname: "",
      position: "",
      companyName: "",
      companyLogoRealUrl: "",
      agentName: "",
      agentLogoRealUrl: "",
      headImgUrl: "",
      mobile: "",
      wecomQrCode: "",
    };
  },
  watch: {
    tenantId(newVal){
      if(newVal){
      this.getUrl();
      this.getInfo();
      }
    }
  },
  mounted() {
      this.getUrl();
      this.getInfo();
  },
  methods: {
    getUrl() {
      const info = window.$sk.template.get();
      const markCode = URLS.getURL("markCode") || URLS.getHash('markCode');
      const taskId = URLS.getURL("taskId") || URLS.getHash('taskId') || URLS.getURL("marketingTaskId") || URLS.getHash("marketingTaskId")
      const tenantId = URLS.getURL("tenantId") || URLS.getHash('tenantId') || ck.cookie('tenantId');
      this.params.markCode = markCode;
      this.params.taskId = taskId;
      this.params.tenantId = tenantId||this.tenantId||info.common.tenantId;
      if (this.$props.preview){
        this.params.markCode=null
      }
    },
   async getInfo() {
     await api.getPromoterInfo(this.params).subscribe(res => {
        this.cardOpenStatus = res.content.cardOpenStatus;
        if (res.content.configInfo) {
          this.buttonType = res.content.configInfo.buttonConfig.type;
          this.buttonStyle =
            res.content.configInfo.buttonConfig.backgroundColor;
          this.linkColor = res.content.configInfo.linkConfig.color;
          this.linkText = res.content.configInfo.linkConfig.text;
          this.linkUrl = res.content.configInfo.linkConfig.url;
          this.logUrl = res.content.configInfo.buttonConfig.imgUrl;
          this.logoLinkUrl = res.content.configInfo.logoConfig.linkUrl;
          this.callmeType = res.content.configInfo.buttonConfig.callmeType;
          this.logoPreview = res.content.configInfo.logoConfig.imgUrl
          if (res.content.configInfo.backgroundConfig.imgUrl) {
            this.bgImg =
              "url(" +
              res.content.configInfo.backgroundConfig.imgUrl +
              ") no-repeat center/100% 100%";
          } else {
            this.bgImg = "url(" + this.bgUrl + ") no-repeat center/100% 100%";
          }
          if (res.content.configInfo.buttonConfig.fixedCallEnabled == "0"&&res.content.promoterInfo) {
            this.phoneNumber = "tel:" + res.content.promoterInfo.mobile;
          }
          if(!res.content.promoterInfo){
            this.phoneNumber='javascript:void(0);'
          }
        }
        if (res.content.promoterInfo) {
          this.promoterType = res.content.promoterInfo.promoterType;
          
          if(this.$props.preview){
            this.uname='史瑞克'
            this.position='业务代表'
            this.headImgUrl=this.headImg
            this.phoneNumber='javascript:void(0);'
          }else{
            this.uname = res.content.promoterInfo.name;
            this.position = res.content.promoterInfo.position;
            this.headImgUrl = res.content.promoterInfo.headImgUrl;
          }
          this.companyName = res.content.promoterInfo.companyName;
          this.companyLogoRealUrl = res.content.promoterInfo.companyLogoRealUrl;
          this.agentName = res.content.promoterInfo.agentName;
          this.agentLogoRealUrl = res.content.promoterInfo.agentLogoRealUrl;
          this.mobile = res.content.promoterInfo.mobile;
          this.wecomQrCode = res.content.promoterInfo.wecomQrCode;
        }
      });
    },
    closeQrCode() {
      this.IsShowQrCode = false;
    },
    callmeFn() {
      if(this.$props.preview){
        return
      }
      this.IsShowQrCode = true;
    },
    closeCard() {
      if(this.$props.preview){
        return
      }
      this.cardOpenStatus = 0;
    }
  }
};
</script>
<style lang="scss" scoped>

/* 移动端样式 */
@media screen and (max-width: 767px) {
  $designVwSize: 7.5;
@function pxToVw($pxz) {
  @if $pxz == -2 {
    @return -1px;
  } @else if $pxz == -1 {
    @return -1px;
  } @else if $pxz == 1 {
    @return 1px;
  } @else if $pxz == 2 {
    @return 1px;
  } @else {
    @return $pxz / $designVwSize * 1vw;
  }
}
p{
  margin-bottom: 0 !important;
 }
.business-card {
  width: pxToVw(700);
  height: pxToVw(228);
  border-radius: pxToVw(20);
  box-shadow: 0px 0px pxToVw(14) 0px rgba(0,0,0,0.14);
  position: fixed;
  margin: 0 pxToVw(25);
  bottom: pxToVw(60);
  left: 0%;
  z-index: 13;
  .card-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: pxToVw(144);
    margin-left: pxToVw(31);
    margin-right: pxToVw(30);
    border-bottom: #cccccc dashed 1px;
    a {
      text-decoration: none;
    }
    .content-info {
      flex: 1;
      display: flex;
      // justify-content: space-between;
      align-items: center;

      .card-header {
        img {
          width: pxToVw(94);
          height: pxToVw(94);
          border-radius: 50%;
        }
      }
      .card-info {
        margin-left: pxToVw(25);
        // width: pxToVw(80);
        .uname {
          // width: pxToVw(84);
          height: pxToVw(40);
          font-size: pxToVw(28);
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: pxToVw(40);
          margin-top: pxToVw(7);
  
        }
        .position {
          // width: pxToVw(100);
          height: pxToVw(36);
          font-size: pxToVw(22);
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: pxToVw(36);
          margin-top: pxToVw(5);
        }
      }
    }
  }
  .mobile {margin-top: pxToVw(30);
    width: pxToVw(166);
    height: pxToVw(52);
    border-radius: pxToVw(30);
    text-align: center;
    line-height:pxToVw(48);
    span{
      font-size: pxToVw(24);
      font-weight: 600;
    }
  }
  .closeBtn{
      width: pxToVw(20);
      height: pxToVw(20);
      position: relative;
      left: pxToVw(660);
      bottom: pxToVw(222);
      img{
        width: 100%;
        height: 100%;
      }
      
    }
  .card-bottom {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: pxToVw(83);
    bottom: 0;
    left: 0;
    right: 0;
    padding-left: pxToVw(31);
    padding-right: 4vw;
    .more{
      font-size: pxToVw(24);
      color: #333333;
    }
    .more::before {
      display: none;
    }
    .cardLogo {
      width: auto;
      height: pxToVw(51);
      object-fit: contain;
    }
  }
}
.showQrCode {
  width: pxToVw(490);
  height: pxToVw(700);
  background: #F3F7FF;
  box-shadow: 0px 0px pxToVw(14) 0px rgba(0,0,0,0.14);
  border-radius: pxToVw(20);
  background: url('../../../assets/codeBg.png') no-repeat center/100% 100%;
  position: fixed;
  left: 50%;
  bottom: pxToVw(50);
  transform: translate(-50%, -50%);
  z-index: 999;
  .top {
    width: 100%;
    padding-left: pxToVw(32);
    padding-top: pxToVw(30);
  }
  //二维码
  .code-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: pxToVw(20);
    .info-left{
      display: flex;
      align-items: center;
      .code-header{
        img{
          width: pxToVw(94);
          height: pxToVw(94);
          border-radius: 50%;
        }
      }
      .code-info{
        margin-left: pxToVw(25);
        .uname{
          font-size: pxToVw(28);
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: pxToVw(40);
        }
        .position{
          font-size: pxToVw(22);
          font-family: PingFangSC-Regular, PingFang SC;
          color: #999999;
          line-height: pxToVw(36);
        }
      }
    }
    .closeBtn{
     img{
      position: fixed;
      top: pxToVw(19);
      right: pxToVw(19);
      width: pxToVw(20);
      height: pxToVw(20);
     }
    }
  }
  .code-company {
    width: pxToVw(432);
    padding-top: pxToVw(20);
    border-top: 1px dashed #CCCCCC;
    .more::before {
      display: none;
    }
  }
  .code-code {
    background-color: #fff;
    width: pxToVw(323);
    height: pxToVw(323);
    padding: pxToVw(24);
    margin-left: pxToVw(54);
    margin-top: pxToVw(36);
    margin-bottom: pxToVw(36);
    box-shadow: 0px 0px pxToVw(16) 0px #E1E1E1;
    border-radius: pxToVw(20);
    img {
      width: 100%;
      height: 100%;
    }
  }
  .code-bottom {
    p{
      font-size: pxToVw(24);
      color: #333333;
      line-height: pxToVw(33);
      margin-left: pxToVw(20);
    }
  }
  .closeButton {
    position: fixed;
    left: 28vw;
    bottom: -13vw;
  }
  .closeCode {
    img{
      width: pxToVw(20);
      height: pxToVw(20);
      position: fixed;
      right: pxToVw(19);
      top: pxToVw(19);
    }
  }
}
}

/* PC端样式 */
@media screen and (min-width: 768px) {
  .business-card {
  z-index: 999;
  width: 435px;
  height: 143px;
  border-radius: 14px;
  box-shadow: 0px 0px 14 0px rgba(0,0,0,0.14);
  position: fixed;
  // margin: 0 pxToVw(25);
  // bottom: pxToVw(60);
  right:49px;
  bottom:49px !important;
  .card-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 90px;
    margin-left: 21px;
    margin-right: 18px;
    border-bottom: #cccccc dashed 1px;
    a {
      text-decoration: none;
    }
    .content-info {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .card-header {
        img {
          width: 58px;
          height: 58px;
          border-radius: 50%;
        }
      }
      .card-info {
        margin-left: 21px;
        p{
          margin-bottom: 0;
        }
        .uname {
          width: 210px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          // height: 25px;
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 35px;
        }
        .position {
          width: 200px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          // height: 36px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 30px;
        }
      }
    }
  }
  .mobile {
    margin-top: 18px;
    width: 105px;
    height: 35px;
    border-radius: 30px;
    text-align: center;
    line-height: 33px;
    span{
      font-size: 14px;
      font-weight: 600;
    }
  }
  .closeBtn{
      width: 13px;
      height: 13px;
      position: relative;
      left:405px;
      bottom: 137px;
      img{
        width: 100%;
        height: 100%;
      }
      
    }
  .card-bottom {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    bottom: 0;
    left: 0;
    right: 0;
    padding-left: 18px;
    padding-right:18px;
    .more{
      font-size: 14px;
      color: #333333;
    }
    .more::before {
      display: none;
    }
    .cardLogo {
      width: auto;
      height: 22px;
      object-fit: contain;
    }
  }
}
.showQrCode {
  width: 303px;
  height: 416px;
  box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.14);
  border-radius: 20px;
  background: url('../../../assets/codeBg.png') no-repeat center/100% 100%;
  position: fixed;
  right: 51px;
  bottom: 228px;
  z-index: 999;
  .top {
    width: 100%;
    padding-left: 19px;
    padding-top: 17px;
  }
  //二维码
  .code-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 13px;
    .info-left{
      display: flex;
      align-items: center;
      .code-header{
        img{
          width: 58px;
          height: 58px;
          border-radius: 50%;
        }
      }
      .code-info{
        margin-left: 21px;
        
        .uname{
          padding-top: 10px;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          line-height: 25px;
      
        }
        .position{
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 36px;
        }
      }
    }
  }
  .code-company {
    width: 265px;
    height: 40px;
    padding-top: 11px;
    border-top: 1px dashed #CCCCCC;
    .more::before {
      display: none;
    }
  }
  .code-code {
    background-color: #fff;
    width: 185px;
    height: 185px;
    padding: 14px;
    margin-left: 32px;
    margin-top: 20px;
    margin-bottom: 13px;
    box-shadow: 0px 0px 16px 0px #E1E1E1;
    border-radius: 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .code-bottom {
    p{
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      margin-left: 20px;

    }
  }
  .closeCode {
    position: fixed;
    right: 64px;
    bottom: 618px;
    img{
      width: 13px;
      height: 13px;
    }
  }
}
}
</style>
